import { EntityModel } from '@/interfaces'
// import { TFunction } from 'next-i18next'
import { format } from 'date-fns'
import { i18n } from 'next-i18next'

export const hydrateEntityObject = (model: EntityModel, object: any) => {
  // const t = i18n?.t
  for (const [name, attribute] of Object.entries(model.attributes)) {
    switch (attribute.dataType) {
      case 'date':
        // set Date object
        // object[name] = new Date(object[name])
        object[`_${name}DateObject`] = new Date(object[name])
        // set formatted date
        object[`_${name}Formatted`] = format(object[`_${name}DateObject`], 'dd.MM.y')
        break
    }

    if (attribute.type === 'entityObject') {
      if (object[name]) {
        // set object id
        object[`${name}Id`] = object[name].id

        // hydrate child object
        // if (attribute.getEntity) {
        //   const model = attribute.getEntity().model
        //   object[name] = hydrateEntityObject(attribute.getEntity().model, object[`${name}`])
        //   object[`_${name}Label`] = model.getDisplayName(object[name])
        // }
      }
    }

    // select labels
    // if (attribute.inputType === 'select' && attribute.selectOptions) {
    //   const index = attribute.selectOptions.findIndex((selectOption) => selectOption.value === object[name])
    //   if (index >= 0) {
    //     // @ts-ignore
    //     object[`_${name}Label`] = t(attribute.selectOptions[index].label)
    //   }
    // }
  }
  return object
}
